import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { OPTIONS } from '@/constants/content'

interface OptionsGridProps {
    className?: string
}

export const OptionsGrid: FC<OptionsGridProps> = ({ className }): ReactNode => {
    return (
        <div className={cn('grid gap-5 sm:grid-cols-2 lg:grid-cols-3', className)}>
            {OPTIONS.map(option => (
                <div
                    key={option.title}
                    className='rounded-2xl border border-border bg-card p-7 transition-[border-color,box-shadow] duration-300 hover:border-primary/30 hover:shadow-[0_20px_40px_-28px_rgb(31_43_36/0.45)]'
                >
                    <span className='flex size-12 items-center justify-center rounded-xl bg-secondary text-primary'>
                        <option.icon className='size-6' aria-hidden='true' />
                    </span>

                    <h3 className='mt-6 text-lg font-semibold'>
                        {option.title}
                    </h3>

                    <p className='mt-2 leading-relaxed text-muted-foreground'>
                        {option.text}
                    </p>
                </div>
            ))}
        </div>
    )
}
